@let helpNeededLabel = 'Hulp nodig?';

<crnt-button
  class="d-none d-lg-inline"
  wlAutomationId="helpNeeded"
  variant="secondary"
  (click)="clicked.emit()"
>
  {{ helpNeededLabel }}
  <crnt-icon slot="leading" icon="messages" />
</crnt-button>
<crnt-icon-button
  class="d-inline d-lg-none"
  wlAutomationId="helpNeeded"
  variant="secondary"
  (click)="clicked.emit()"
>
  <crnt-visually-hidden>
    {{ helpNeededLabel }}
  </crnt-visually-hidden>
  <crnt-icon icon="messages" />
</crnt-icon-button>
